import { cn as e } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tai_b48471231fd1734d96945a2b3d8654eb/node_modules/tailwind-variants/dist/index.js";
import { useConfigProvider as t } from "../../config-provider/useConfigProvider.js";
import "../../config-provider/index.js";
import { reactiveOmit as n } from "../../../../node_modules/.pnpm/@vueuse_shared@13.3.0_vue@3.5.16_typescript@6.0.2_/node_modules/@vueuse/shared/index.js";
import { useForwardPropsEmits as r } from "../../../../node_modules/.pnpm/reka-ui@2.5.1_patch_hash_1a_da296058102805d3e82696b7a23dd27c/node_modules/reka-ui/dist/shared/useForwardPropsEmits.js";
import { TooltipArrow_default as i } from "../../../../node_modules/.pnpm/reka-ui@2.5.1_patch_hash_1a_da296058102805d3e82696b7a23dd27c/node_modules/reka-ui/dist/Tooltip/TooltipArrow.js";
import { TooltipContent_default as a } from "../../../../node_modules/.pnpm/reka-ui@2.5.1_patch_hash_1a_da296058102805d3e82696b7a23dd27c/node_modules/reka-ui/dist/Tooltip/TooltipContent.js";
import { TooltipPortal_default as o } from "../../../../node_modules/.pnpm/reka-ui@2.5.1_patch_hash_1a_da296058102805d3e82696b7a23dd27c/node_modules/reka-ui/dist/Tooltip/TooltipPortal.js";
import { tooltipContentVariants as s } from "../styles/index.js";
import { createBlock as c, createVNode as l, defineComponent as u, mergeProps as d, normalizeClass as f, openBlock as p, renderSlot as m, unref as h, withCtx as g } from "vue";
//#region src/components/ui/tooltip/core/TooltipContent.vue?vue&type=script&setup=true&lang.ts
var _ = /* @__PURE__ */ u({
	inheritAttrs: !1,
	__name: "TooltipContent",
	props: {
		class: {},
		forceMount: { type: Boolean },
		ariaLabel: {},
		asChild: { type: Boolean },
		as: {},
		side: {},
		sideOffset: { default: 4 },
		align: {},
		alignOffset: {},
		avoidCollisions: { type: Boolean },
		collisionBoundary: {},
		collisionPadding: {},
		arrowPadding: {},
		sticky: {},
		hideWhenDetached: { type: Boolean },
		positionStrategy: {},
		updatePositionStrategy: {}
	},
	emits: ["escapeKeyDown", "pointerDownOutside"],
	setup(u, { emit: _ }) {
		let v = u, y = _, b = r(n(v, ["class"]), y), { teleportRenderDisabled: x } = t(), S = s();
		return (t, n) => (p(), c(h(o), { disabled: h(x) }, {
			default: g(() => [l(h(a), d({ "data-slot": "tooltip-content" }, {
				...h(b),
				...t.$attrs
			}, { class: h(e)(h(S).base(), v.class) }), {
				default: g(() => [m(t.$slots, "default"), l(h(i), { class: f(h(S).icon()) }, null, 8, ["class"])]),
				_: 3
			}, 16, ["class"])]),
			_: 3
		}, 8, ["disabled"]));
	}
});
//#endregion
export { _ as default };

//# sourceMappingURL=TooltipContent_vue.js.map